// extracted by mini-css-extract-plugin
export default {"date":"DateTime_date__TQWq3"};